const awsConfig = {
  region: 'ap-northeast-1',
  // when not specified, always use the dev environment
  userPoolId: process.env.REACT_APP_USER_POOL || 'ap-northeast-1_YHwJ6UTt2',
  appClientId: process.env.REACT_APP_CLIENT_ID || 'nh8p51ls6g5fuen68ls6htam3',
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID || 'nh8p51ls6g5fuen68ls6htam3',
  apiURL:
    process.env.REACT_APP_API_URL ||
    'https://cegz8jalzd.execute-api.ap-east-1.amazonaws.com/latest',
  nkApiURL:
    process.env.REACT_APP_NK_API_ORDER_URL || 'https://dbserver9.nkcl.com.hk:8443/NKWebApp/order',
  nkApiToken: process.env.REACT_APP_NK_API_ORDER_TOKEN || 'L3hdclF83U8FRL7Ow',
};

export default awsConfig;
